module.exports = __webpack_public_path__ + "static/img/shorthand.8e67c58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/subtitle/shorthand.png
// module id = 9j1n
// module chunks = 1